












































































import { Component, Watch, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required, minValue, maxLength } from 'vuelidate/lib/validators';
import {
  Form,
  FormInput,
  Textarea,
  Select,
  GenderLibrary,
} from '@/pages/profile/blocks';
import { Button } from '@/pages/profile/components';
import genderLibrary from './genderLibrary';
import { validateGender, validateAgeValueBetween } from '@/tools/validatefio';
import { FormData, IMentoringNewRequestForm, Dictionsry } from './types';
import { dataParcer } from './dataparcer';
import { DESCRIPTION } from './consts';

const getData = () => ({
  title: '',
  text: '',
  gender: '',
  mentor: '',
  ageFrom: '',
  ageTo: '',
  time: '',
});

@Component({
  components: {
    Form,
    FormInput,
    Textarea,
    Select,
    Button,
  },
  mixins: [validationMixin],
})
export default class MentoringNewRequestForm
  extends Vue
  implements IMentoringNewRequestForm {
  public resultForm: FormData = getData();

  public description: string = DESCRIPTION;
  public genderSelect: GenderLibrary = genderLibrary;

  get isDisabled(): boolean {
    const { $v } = this;
    return $v ? $v.$invalid : true;
  }

  get v(): any {
    return (this as any).$v.resultForm;
  }

  get mentoringTypes() {
    const { MentoringTypes } = this.$store.state;
    return MentoringTypes.filter(
      ({ id }: Dictionsry) => id !== 2
    ).map(({ id, name }: Dictionsry) => ({ text: name, value: id }));
  }

  validations(): any {
    const resultForm: any = {
      title: { required },
      text: { required, maxLength: maxLength(500) },
      gender: { required, validateGender },
      mentor: { required },
      ageFrom: { required, minValue: minValue(10) },
      ageTo: { required, validateAgeValueBetween },
      time: { required },
    };

    return { resultForm };
  }

  mounted(): void {
    this.reset();
  }

  submitRequestForm(): void {
    const { $v, resultForm } = this;
    if ($v) {
      $v.$touch();
      if (!$v.$invalid) {
        this.$emit('submitRequestForm', dataParcer({ ...resultForm }));
      }
    }
  }

  reset(): void {
    const { $v } = this;
    if ($v) $v.$reset();
    this.resultForm = { ...getData() };
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/requestform/MentoringNewRequestForm.vue